const googleDocsRegex =
  /https:\/\/docs\.google\.com\/(document|spreadsheets|presentation|forms)\/d\/([a-zA-Z0-9_-]+)/;
const googleDriveRegex =
  /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
const oneDriveRegex =
  /https:\/\/[a-zA-Z0-9\-]+\.sharepoint\.com\/.*\/([a-zA-Z0-9_-]+)(?=\?)/;

export function getDocumentId(url) {
  let documentId = null;

  if (googleDocsRegex.test(url)) {
    const match = url.match(googleDocsRegex);
    documentId = match[2]; // Extract document ID from Google Docs URL
  }

  if (googleDriveRegex.test(url)) {
    const match = url.match(googleDriveRegex);
    documentId = match[1]; // Extract file ID from Google Drive URL
  }

  if (oneDriveRegex.test(url)) {
    const match = url.match(oneDriveRegex);
    documentId = match[1]; // Extract file ID from OneDrive URL
  }

  return documentId || "";
}

export function isDocumentValid(url) {
  return (
    googleDocsRegex.test(url) ||
    googleDriveRegex.test(url) ||
    oneDriveRegex.test(url)
  );
}